<template>
  <div class="page page-companies">
    <h3>Организация</h3>
    <ActionBar
      :isEditing="isEditing"
      @changeAction="changeCompany"
      @cancelAction="cancelCompanyChanges"
      @deleteAction="deleteCompany"
      @saveAction="updateCompany"
    />
    <br />
    <CompanyEditForm v-if="isEditing" class="company-view-edit" :company="company" />
    <CompanyShowForm v-else class="company-view-edit" :company="company" />
  </div>
</template>

<script>
/* eslint-disable camelcase */

import Swal from 'sweetalert2'
import deepAssign from 'assign-deep'
import companiesAPI from '@/api/companies'

export default {
  name: 'CompanyPage',
  props: ['id'],
  data () {
    return {
      isUpdating: false,
      prevCompany: null,
      company: {},
      isEditing: false
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    updateCompany () {
      if (this.isUpdating) {
        return
      }
      this.isUpdating = true
      companiesAPI.updateItem(this.company)
        .then(company => {
          this.company = company.model
          this.isUpdating = false
          this.isEditing = false
        })
        .catch(text => {
          this.isUpdating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    loadData () {
      companiesAPI.getItem({ id: this.id })
        .then(response => {
          this.company = response
        })
    },
    changeCompany () {
      this.prevcompany = deepAssign({}, this.company)
      this.isEditing = true
    },
    cancelCompanyChanges () {
      this.company = this.prevcompany
      this.isEditing = false
    },
    deleteCompany () {
      companiesAPI.removeItem(this.company.id)
        .then(() => {
          this.$router.push('/companies')
        })
        .catch(text => {
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>

<style scoped>
  .page-companies {
    width: 98%;
    padding-bottom: 4rem;
    padding-top: 2.5rem;
  }
</style>
